import { useSuspenseQuery } from '@tanstack/react-query';
import { getAllOrganizationsQuery } from '../api';

/**
 * Hook to get all organizations for the current user.
 * Reads from React Query cache populated by the Ember organization-manager service.
 *
 * @returns Array of organizations
 */
export function useOrganizations() {
  const { data } = useSuspenseQuery(getAllOrganizationsQuery());
  return data;
}
